
import Component from '../src/components/Internal/AdsStandard.vue';

// Register component globally without any prefix if Vue is available.
if (typeof window !== 'undefined' && window.Vue) {
  window.Vue.component('ads-standard', Component);
}

export default Component;
    